import React from 'react';
import { Switch } from 'react-router-dom';
import { usePageTracking } from '../hooks/usePageTracking';

export const SwitchWithPageTracking: React.FC<{ prefix?: string; children?: React.ReactNode }> = ({ children, prefix }) => {
    usePageTracking({ prefix });

    return <Switch>{children}</Switch>;
};
